import { useSupportContext } from '../../core/context/SupportContext';
import Header from '../../components/Header/Header';
import SupportBanner from '../../components/SupportBanner/SupportBanner';
import SharedApps from '../../components/SharedApps/SharedApps';

function Support() {
  const { banner, sharedApps } = useSupportContext();

  return (
    <>
      {/* Implement desktop layout */}
      <Header title="support" isWhite />
      <SupportBanner data={banner} />
      <SharedApps data={sharedApps} />
    </>
  );
}

export default Support;
